
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoarUPHlqJgKhQdnu3B9vDeq8GtWcyhhNgyJLvnSFQpqoMeta } from "/var/www/2025-06-27_10_19/pages/edo.vue?macro=true";
import { default as helpLYhABe7ZNAdqNfLg2uOPYlhgdBXJGNjxz5GKhCR5nQcMeta } from "/var/www/2025-06-27_10_19/pages/help.vue?macro=true";
import { default as cargovIjkPRkPqxTKwCGy0a3FLlbfDet2eSGn1fP3AIC7PbwMeta } from "/var/www/2025-06-27_10_19/pages/cargo.vue?macro=true";
import { default as indexY32AIR41kvba7BSB1976I8aqDOPGs50VXO5ZMgyFx6MMeta } from "/var/www/2025-06-27_10_19/pages/index.vue?macro=true";
import { default as _91slug_93oHiNnPNQ04MwioAiy83LbBnlH6CqHCk1ujyPV_45tg_459UMeta } from "/var/www/2025-06-27_10_19/pages/[slug].vue?macro=true";
import { default as cookie_45FtD2Dvud1B2kmtTk2YxUpjSxtte9eAK4Qpp4NpqYjsMeta } from "/var/www/2025-06-27_10_19/pages/cookie.vue?macro=true";
import { default as belarusj5zOLPlrXs_454gTj5DwhA4fgyzU_453_K0zuainqGPWQhAMeta } from "/var/www/2025-06-27_10_19/pages/belarus.vue?macro=true";
import { default as bonusesQYwApYxZ9nAOENvDlwWLc6ax49HpfcZyJnrue_wnW_kMeta } from "/var/www/2025-06-27_10_19/pages/bonuses.vue?macro=true";
import { default as apiOTqgQhL0_yo8UBoAiFHY_45rmsGw75ELrPUGyOTIRdEeYMeta } from "/var/www/2025-06-27_10_19/pages/dev/api.vue?macro=true";
import { default as cms4umcRKGLkTOSi2DGjSncklVvzKcf0yWgifWMi9B0g0EMeta } from "/var/www/2025-06-27_10_19/pages/dev/cms.vue?macro=true";
import { default as konkursQ4gPSAyj7tTvKCfaP5Qtn0kj_eE_Ep2v83jFkLaGU4sMeta } from "/var/www/2025-06-27_10_19/pages/konkurs.vue?macro=true";
import { default as successDApbL8mM8KzLtpJ9MgJufu2PNLKHHq0odX1jJGfH__45kMeta } from "/var/www/2025-06-27_10_19/pages/success.vue?macro=true";
import { default as tariffsSSQ0KQmVg75mJTGPcSxj5Me_45kyiXlk5OLehRAFEN4_45sMeta } from "/var/www/2025-06-27_10_19/pages/tariffs.vue?macro=true";
import { default as vacancyu3YGFOCaVxsYR5Hr5HZ_C2g2IHUJcD5igwRYpQtmuGMMeta } from "/var/www/2025-06-27_10_19/pages/vacancy.vue?macro=true";
import { default as contactstoN8pWka_454dd1vJ2yOgZg0uWG35_453dwC8vjQyYrr5o0Meta } from "/var/www/2025-06-27_10_19/pages/contacts.vue?macro=true";
import { default as giveaway3mztHNJAkQzT5XQj3FEz7waODeIRvZWUaQOdqP0DBIsMeta } from "/var/www/2025-06-27_10_19/pages/giveaway.vue?macro=true";
import { default as guide_45lkaRy5kkhueWj8C3Po7RdU12G6nL_45R2PEkbaO_stfWlbcMeta } from "/var/www/2025-06-27_10_19/pages/guide-lk.vue?macro=true";
import { default as servicespY_45A9SoII0JSAUf8OdRjxeqh_457vxADKTnpPT_Yp7pSkMeta } from "/var/www/2025-06-27_10_19/pages/services.vue?macro=true";
import { default as telegram6eC_45_45wqVMgw2rqrBzN5y1KKR4v4b5Oe52HvlfsMjbKgMeta } from "/var/www/2025-06-27_10_19/pages/telegram.vue?macro=true";
import { default as documentsK8xllLzh2pZkPGS0XrMdlxXePwtfuNFXNd5JhgW_45aKQMeta } from "/var/www/2025-06-27_10_19/pages/documents.vue?macro=true";
import { default as franchisevJ6b6zRTbxUzsM8w1BkJ7HDcOw3sRSDQejw750LIo20Meta } from "/var/www/2025-06-27_10_19/pages/franchise.vue?macro=true";
import { default as insurance8eIyCvvDx9BNAnuGqQV4u46s__e7OgbF5uld57jS5poMeta } from "/var/www/2025-06-27_10_19/pages/insurance.vue?macro=true";
import { default as kirghiziaB16NQMaZ8x8_QGxxcRjIEtdve8RisjNV4CCq7GNASK4Meta } from "/var/www/2025-06-27_10_19/pages/kirghizia.vue?macro=true";
import { default as mapSchemeIBcQ7iwkZfuj_Ly42DoXxymmAKJsHy7JG_T4Ji3wfEUMeta } from "/var/www/2025-06-27_10_19/pages/mapScheme.vue?macro=true";
import { default as _91id_93UGFK4zVHEKZKc9ILVJN9BV5N9g6t_45FqtbAbs2bKeuhIMeta } from "/var/www/2025-06-27_10_19/pages/news/[id].vue?macro=true";
import { default as return_45sdoXWbdWnnctYsgm_45UCSk85077XdlXzC_45r_Nls7Bt987AMeta } from "/var/www/2025-06-27_10_19/pages/return-sd.vue?macro=true";
import { default as smsClientfQbpk7jLpRogHvHKcBCi3t9Pw6YCVxSGBxG7wpM3D7oMeta } from "/var/www/2025-06-27_10_19/pages/smsClient.vue?macro=true";
import { default as terminalsclkUGO_45_45_eYLDj_45KgkLRTgOkm3UplAB9a9odI6_45NJAAMeta } from "/var/www/2025-06-27_10_19/pages/terminals.vue?macro=true";
import { default as iframeLi820nS9_45i03q4dW89BKG9HoBZggCh09yojgDJlw9pMMeta } from "/var/www/2025-06-27_10_19/pages/dev/iframe.vue?macro=true";
import { default as directionsZ0X9RcO_kiZ8pN_455J1tN2LMTr7BhlHW6doh0RQPzM0gMeta } from "/var/www/2025-06-27_10_19/pages/directions.vue?macro=true";
import { default as kazakhstanXyl_45HbLMLvFyOEbpA9UhN5H5Nh2A740VoWP0R_R0RS8Meta } from "/var/www/2025-06-27_10_19/pages/kazakhstan.vue?macro=true";
import { default as indexfxeKW_H6OlKMm96tcN_45V7CqjxYjE4MPq4muk9RHA8roMeta } from "/var/www/2025-06-27_10_19/pages/news/index.vue?macro=true";
import { default as svgM_45xNWFlyw_45pL2eN05EZbXVArL7rlUl4NUXinl8OeAUMMeta } from "/var/www/2025-06-27_10_19/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failFd_45Uz6hfrJWbfJrNcM6MSNbXxznNfuSI4BbfPAvtIbcMeta } from "/var/www/2025-06-27_10_19/pages/vzpay-fail.vue?macro=true";
import { default as constructorJw2E7AwA1f6_WjQrJgTbxPCQanmiX4bVMCMmKCgzIAgMeta } from "/var/www/2025-06-27_10_19/pages/constructor.vue?macro=true";
import { default as indexjvJRdaAI54ZKqoltrof_45_45VUG6Ri1_45TBm0lsZseu_45U5sMeta } from "/var/www/2025-06-27_10_19/pages/gifts/index.vue?macro=true";
import { default as informationcaedJce6uw83Oh4_45PshRJqChWnygkQzfMZBZkcQn9_45wMeta } from "/var/www/2025-06-27_10_19/pages/information.vue?macro=true";
import { default as lightfy43H12oasSt8kL2_45YomV5CvRxnWOlV1u8hg62B__45_MMeta } from "/var/www/2025-06-27_10_19/pages/order/light.vue?macro=true";
import { default as claim_45filingtSdFu9hy78kpnePg5yAt09XYIxgH89EJNd8pD_454uOBUMeta } from "/var/www/2025-06-27_10_19/pages/claim-filing.vue?macro=true";
import { default as _91type_93glYDErLeCSd4JI7NUGFoCUKjz9rkdBpE5FBl1GK0iFYMeta } from "/var/www/2025-06-27_10_19/pages/gifts/[type].vue?macro=true";
import { default as marketplacesUTWg9r24VU4_2KcNNfgqjzLjJ6WhIqlI5V7pfD2_459VEMeta } from "/var/www/2025-06-27_10_19/pages/marketplaces.vue?macro=true";
import { default as networkshopsT0kb_OJ0E_X1pgedD_45gERVOL54hk9WBqHOVM6zPNwdwMeta } from "/var/www/2025-06-27_10_19/pages/networkshops.vue?macro=true";
import { default as online_45storepF4wKzHUnXP9DH6k9hsphmkBljrVNsFasdSqdJ0oH68Meta } from "/var/www/2025-06-27_10_19/pages/online-store.vue?macro=true";
import { default as manageiqIsPUKto23o_T08ExrmtgC3PgUeKW6rN8TkEf8sffQMeta } from "/var/www/2025-06-27_10_19/pages/order/manage.vue?macro=true";
import { default as registrationODDokTrUXD_qFrZqr2K8JpHD4MSMYNl16kIixltN_7EMeta } from "/var/www/2025-06-27_10_19/pages/registration.vue?macro=true";
import { default as run_45schedule2oTSZgV4zzP9FSKy5IKi7YH_5SGVsUmZwMvplGAgYuQMeta } from "/var/www/2025-06-27_10_19/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyz4D6d2bRWKYGmX8THFvMx4f_45EbRWktxIuM3kXMnzC5wMeta } from "/var/www/2025-06-27_10_19/pages/safe-custody.vue?macro=true";
import { default as imageDmN_IrXaf1KX96K9K5zO2L6g48mYajWbTQwxghFAd1oMeta } from "/var/www/2025-06-27_10_19/pages/ui-kit/image.vue?macro=true";
import { default as index_Rpn4C_45uetX3ZeTGA4GBKOcdh6g1sDk7_dEvJ6FQ9RMMeta } from "/var/www/2025-06-27_10_19/pages/ui-kit/index.vue?macro=true";
import { default as bag0fW_45DwRU_45txA5GE4zfUjCo6whImRNoMTyI7zkNzbuPgMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/bag.vue?macro=true";
import { default as boxbL_OQKHzot85lFb2rE7Xg9xlVQFeX1oFkqkFl7E4PWAMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingmEw_CC7zep1Oj4Ks4GM_45ayzhagu1h_45Dacg0n_45JZT14cMeta } from "/var/www/2025-06-27_10_19/pages/cargo-loading.vue?macro=true";
import { default as happybirthday2FrupHA9Y4JFOT2HMMBxhqY2tvE_45M1KgDO6Kt1t1tQYMeta } from "/var/www/2025-06-27_10_19/pages/happybirthday.vue?macro=true";
import { default as managey3CKEMEOjvRl_45XhKb_Jf_rGEBfCU5ovMNhK0g9YA9twMeta } from "/var/www/2025-06-27_10_19/pages/iframe/manage.vue?macro=true";
import { default as authxehAasGNHSfrAcvl2r8uGOxRErJfAmdGmXjFXul_45BN4Meta } from "/var/www/2025-06-27_10_19/pages/personal/auth.vue?macro=true";
import { default as publicGki4zYXbP_XUBG4oWdjp2Ei__45c8whmLbLfNqUxk1BHUMeta } from "/var/www/2025-06-27_10_19/pages/ui-kit/public.vue?macro=true";
import { default as already_45answer2ZWfqB1Boa6ASsm3BFu10zN_45SlTqPJlxz5QE44viYTEMeta } from "/var/www/2025-06-27_10_19/pages/already-answer.vue?macro=true";
import { default as tariffsoPX92EaxCLzXVxEadUjsSo6mMpWvDbMc_1Xi6YLhIyAMeta } from "/var/www/2025-06-27_10_19/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93NF1rS7wILIWSayLryYQT28HwT1YBiuPWZm1xthgY_458oMeta } from "/var/www/2025-06-27_10_19/pages/order/pay/[id].vue?macro=true";
import { default as indexE6CKGH5FR8ZuamXwly_UrxFMIM7WkM_45XYtpmXjOGJwgMeta } from "/var/www/2025-06-27_10_19/pages/personal/index.vue?macro=true";
import { default as privacy_45policyKJberbj7_45MCm5m3Uekbn7xNe9TuQwMbjqr59Q9pGz78Meta } from "/var/www/2025-06-27_10_19/pages/privacy-policy.vue?macro=true";
import { default as _91hash_935U_45dfbcfkdJBvyA0dwnNCAxAbAcYiWo1ZLKA8pRsFTkMeta } from "/var/www/2025-06-27_10_19/pages/welcome/[hash].vue?macro=true";
import { default as indexx_3Dd4UE9wvxaQRh7vdFljRtLRu0sX_SwhqAYTi_45dzAMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiaL29ORYLDjiO9hNe5eyPQAi0ejBwAyrT1EgFH24mFxIwMeta } from "/var/www/2025-06-27_10_19/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsnDfK1QL_F0_pDif4BKqXcSHGeukuXYhJhYSJISc_45rEIMeta } from "/var/www/2025-06-27_10_19/pages/payment-methods.vue?macro=true";
import { default as qr_45infoX0HvybfIekYRPbZMFLTAckdaH7f9GkdgkhYcoQ2TNS8Meta } from "/var/www/2025-06-27_10_19/pages/payment/qr-info.vue?macro=true";
import { default as successvpgcMIbMN_aYY4XfkdWBEYYJZXmH_45Uix7S6SdG_5AHoMeta } from "/var/www/2025-06-27_10_19/pages/payment/success.vue?macro=true";
import { default as import1oMvRCTHFrU1JAZOmVpMR18lu65fMdyHyaSbj2ZvoOgMeta } from "/var/www/2025-06-27_10_19/pages/personal/import.vue?macro=true";
import { default as logoutJ_454FT7r2bHPhvl_tkFnOpYrG_456fQhYNTzXsmmendfXgMeta } from "/var/www/2025-06-27_10_19/pages/personal/logout.vue?macro=true";
import { default as address_45deliverywTaASKWQvVld2ge6BniLQ41Lfu0SnE1HqTJkh2IXhzEMeta } from "/var/www/2025-06-27_10_19/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliverynphPGVTkFz1OFBf3fyO49sXjyq6gzdKjvyg6h4uzhfoMeta } from "/var/www/2025-06-27_10_19/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20247RS_eNCF1JsVPLJFz6T_uPYFDfZx_eKgXBCpp0ar2LIMeta } from "/var/www/2025-06-27_10_19/pages/happynewyear2024.vue?macro=true";
import { default as ozon87bWWNgxgnNdJgRg9oUbvQOVUxc4eOkK31yfwb86U2YMeta } from "/var/www/2025-06-27_10_19/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45faillb02me_eOY6DMaQBWtmyAqtWJ0ddGKlgKqc_45RQwX9AcMeta } from "/var/www/2025-06-27_10_19/pages/payment/pay-fail.vue?macro=true";
import { default as accountGcHQrqP3fYT0_bRVnzi9gkX_uGLstsrGUbjXR9wE6TwMeta } from "/var/www/2025-06-27_10_19/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods5wP0eBqDov9EKPnax0kQpwP8S9SrXXTQImsuQsKywPYMeta } from "/var/www/2025-06-27_10_19/pages/prohibited-goods.vue?macro=true";
import { default as directionsOwX51Z8R1XnbzTdwQOy8R_45RW_GPL3pJY_45jhJzV8dvEMeta } from "/var/www/2025-06-27_10_19/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupk4mLq7sLj0UPradXFmi6Oc_45Q1_uXUP8pl_45vT_45EJ_jUsMeta } from "/var/www/2025-06-27_10_19/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargolFvy9VgBvWGr6SBn8L9Sd6sPvfYIRiGvOjwANjNNhSAMeta } from "/var/www/2025-06-27_10_19/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorNl6KdcIqTxou89a3FAVRbK5YmBJpp6WUYnYq85MWPOwMeta } from "/var/www/2025-06-27_10_19/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesKv3s3cxoqNH7ZZsgrPTbDVo9vece_45Vgn6mS6IKWR0EkMeta } from "/var/www/2025-06-27_10_19/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93ev6tn53Su4X40UVk1dKJbo_Jh_B3iuLiqeGFfCLEScoMeta } from "/var/www/2025-06-27_10_19/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoLgFpr0j2ACB2jnhDimQ5GvCDW4cqzwYyfb_46d82m8EMeta } from "/var/www/2025-06-27_10_19/pages/payment/card-info.vue?macro=true";
import { default as discountR403Xfg_45SzEL_RfM2dL5d82X_7vuShwWaPtd_45tOrxeQMeta } from "/var/www/2025-06-27_10_19/pages/personal/discount.vue?macro=true";
import { default as hard_45boxnu_46yeUkPoXmZQzuAhuPG7dDWcs2lVohQyXGL9s6oYMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptKHUvrv_45rD3cwcft8_45NyNtzc2OmBvBuT0LxhhIVBCjGYMeta } from "/var/www/2025-06-27_10_19/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient102019170ifR9w6v1lgyE9qGKbSKy1RU_45LP98K1bPmcLznIDXfEMeta } from "/var/www/2025-06-27_10_19/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationgRVu8sVCSrZ_1j_45S_45A59xxp5uGWsGEGgX69gGj05s3QMeta } from "/var/www/2025-06-27_10_19/pages/mobile-application.vue?macro=true";
import { default as index0TABsiajq9EzNtF_op4ZP901mbg7qO7rCFmGGFwgbNEMeta } from "/var/www/2025-06-27_10_19/pages/order/create/index.vue?macro=true";
import { default as boatky3qIFHBwSwI91PZ3er8XCUe97pSNPrnfQtZM8UHVNAMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/boat.vue?macro=true";
import { default as sofakpjxzD6KP8XaeZWZMA1qs9Qw1sTmCDzTjlO8b_M0Ks0Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardGXxcV2Df7cc_W2FH_9Rmh57elyylpnYOL3zwyZsR_45bkMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesAiGX4_45wI1g0I0ozLXlugoRcfIHZmGH3qmqKFv7ajzAsMeta } from "/var/www/2025-06-27_10_19/pages/personal/promocodes.vue?macro=true";
import { default as benchqwGAcmpF9WKc_45SgQawxBhlZs2I2u0CfKpLs2DbrOlGkMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/bench.vue?macro=true";
import { default as booksbK0S_AQDCMIKjM8drV5VUbM89jQBiFX5JP3tntZBi9AMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/books.vue?macro=true";
import { default as cableDsJYk2Cp46tCbNyoE28D7kPOoFtij5igCJaF47aEXUkMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/cable.vue?macro=true";
import { default as chairMr9Vka5Ipo1XdcPwDn5mGJjpBgE6RL5sgLrVoS2zPigMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsQuGG0Z5iCjtwv0VSH8gkwWJzf4XddhBYAIg1ISh0uzIMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/goods.vue?macro=true";
import { default as index6aY0_45_IbZxN9254ksjprK2pNuhSg66fI4tyDiuUmsFgMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/index.vue?macro=true";
import { default as metal1sRSEAqbDq8ThB2IkwxP37BgNEsLwY2_45J0PI4DGIScsMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoREoPl_xPcE9fxqzPSqJnDxEelA4qWChKw_evK84P_452MMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesbGtFyMJ69KuBDx1PK_45ZwUp5Qvq7a8hIJCaTd_WdK_XoMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsZyVDVOeHX5PoYXPX3Ju615Zd2TQTAi0PKqURL6FJ8D4Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxmOME9RyvCb5FGB_KKIL8_ZReTzRmpQZNgxZ0oEgssVQMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_931Boc5aR0fZS5vD6bfLxIf5LyNMCGkJpJXgdOHYvX9GYMeta } from "/var/www/2025-06-27_10_19/pages/personal/bonus/[tab].vue?macro=true";
import { default as printr7521oBYlctHYScsxVK9qfOzOqGWrUfuuzCef6ytLYIMeta } from "/var/www/2025-06-27_10_19/pages/personal/order/print.vue?macro=true";
import { default as dishesA5SgzKNyCKcKSiVRpnrlesND5PZYGzsO92sWhwtCOlAMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/dishes.vue?macro=true";
import { default as engine7UxbyGcILGOyd1lNEAznAcSgitggkqPqmsgKeArxsDoMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberqS4MQCYk1QEq6HCKdWZdeHRotKsNxULonUP_45cbgrRv8Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsZsjI1HnjEhJoH_TXorVS8VD2yvLVY9pXiCX9h48ziRoMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmsNeqrK663BNVRpHA49_45_SRsgUqr2rjmZxQ1hRRxDGOIMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletising6PSZgs8Y8BJsB59tz_TJPdOq0p_45s6DiGpwNEF9CMqbwMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalXLtW3Ej8sF5lR32rJamN_451mPOJt__wjY4WBP99VZMH4Meta } from "/var/www/2025-06-27_10_19/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_9356bSwP1iZxDYmwxZZ7paCT6mR6ylBrjti6uROaucEQgMeta } from "/var/www/2025-06-27_10_19/pages/personal/order/[guid].vue?macro=true";
import { default as createLF1Z_za5_61HKh1l0B44lura9kPDVh1AXBsOJxPrVBYMeta } from "/var/www/2025-06-27_10_19/pages/personal/order/create.vue?macro=true";
import { default as barrelsSlJG0joMMinYtZ2ak5P2nPic2luAmxiYvubCtwYF2NMMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesX5tzeccz2qrKwoZMBAnlAxjS8yb14dBES3F3fU8NkQQMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileMsEC_45ZFVy3WsS1ETA_AhC3Z4RBkt9PGChCwzTv2uck0Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerBW_nU5lVbtNJPwBgrBMMsj4cR15YZkJVrNNiRZ3tUpQMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packageDmcVO4JgAMue_fFf4E653CZKN_45TDIcQZuPJ2Q4OetqMMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successvJn4WKS3I530M_d1trmipRxuKD5fd4cccQvGgt001ikMeta } from "/var/www/2025-06-27_10_19/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packagezOLbkLOyeHa0YIAXktm0lgh4fiPTqLfzoNWFFeOexokMeta } from "/var/www/2025-06-27_10_19/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesVH0LbpJklTze26Icc1MtuzWAFh8oGI_hWA_45W4EVd4i4Meta } from "/var/www/2025-06-27_10_19/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93pes_45uCRArPz8Hyy_fweWaNjpmCEuR9zPtYfRH7_45wlWMMeta } from "/var/www/2025-06-27_10_19/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureuGWUMG9c5cJlI12hD6THqHXpecXkWg_45K6Jn7K_45jqVH0Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedvUh47R0iDC0kH4fv_45gwUbMbV4PqVaPXtrJRQySLF1doMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bike8oiPhs83LbsWqmXWyMNPEGN_OByDpg_451yuPB6UZsbwwMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93GyzlNqUGThiBhqciEA_fVCzDnoO8vNG6s16UNNWS0zIMeta } from "/var/www/2025-06-27_10_19/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93ABWd3FkHuqpPLd5fKzCflQgFUmJwvbf9uSFYeK_455B0AMeta } from "/var/www/2025-06-27_10_19/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsadWQ9mzkFJN_5qGIDcUVw_45S86IT8rQ4E5dhgLJwTuR0Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersqngj7hkj10Q0etx2FS_rcjWxqh6oyDHCZ4nnTwSr5rcMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoVLDSOSSVPqfEa9u_45YWMQJQVrDEZQaRpfBGOdPEOknRUMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilegtvv6qM9u87MAA9U6In4xwUQx3HRsSKt1kNEyPuErwgMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexnqlEPnEFI5w81O_454RA2_kPZPw8ezB_45xMFyF9k3m_GskMeta } from "/var/www/2025-06-27_10_19/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketCFSaQSVXMrWZy4r4DZHjDI8R1xS0pNNQuyeYg0lf7NsMeta } from "/var/www/2025-06-27_10_19/pages/marketplace/yandex-market.vue?macro=true";
import { default as templateskbi_dLXZF48ySs62DTz7bwQ_nMN8SuyNgSVcogPzErgMeta } from "/var/www/2025-06-27_10_19/pages/personal/orders/templates.vue?macro=true";
import { default as indexytSm9rUJGwa6dp_pBjyg3zqPlOO9IJbNzyumGTgiOjMMeta } from "/var/www/2025-06-27_10_19/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratormKQS_459sYxLPpkm_4573p6Nrm_uxUqxM0FqYAGk_Al_Y0sMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93LqcglZ4QSMtcgfgv0O4DrU0Gu1Ne_45u0PAZlUAjKCXpsMeta } from "/var/www/2025-06-27_10_19/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexKtnTNUzV_DOyv8DG5tr91A96M1suC6Zxsdo8O29ONR8Meta } from "/var/www/2025-06-27_10_19/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93GkBOftLlCTsb4q9VWY_45JwRTZmeqSBLYhIQYthyFv_vYMeta } from "/var/www/2025-06-27_10_19/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goods0AFck2Dgf1oo3e6ZJggdJwrpsPLAUw6MQkX82_45e_pjsMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as index1DpbrdYMt_9cRu40kP2Euh2RCoduZADhKQoFCFPqhP0Meta } from "/var/www/2025-06-27_10_19/pages/personal/group-printing/index.vue?macro=true";
import { default as indexCuTwELQGNA22yDDT_45_45qi1B_EHj1KwJCPAo_CQHLmdhIMeta } from "/var/www/2025-06-27_10_19/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesvG_efY8VCm0s6AAiluTSdOSsV2ZO_45B4dhKWQqBu_KdcMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93DtIVpPuCeDZXJ3pid6mxm_45_45dCAZq9sywUT_455y2i2QEwMeta } from "/var/www/2025-06-27_10_19/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93QqB5v0YGNNAS8OunNXbc_45Oc3As_45yy_45c18ummU6qG8LUMeta } from "/var/www/2025-06-27_10_19/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93UU8RBjrTvuCCG3Mafd6ico5w7B63mOULLX587m4JgUQMeta } from "/var/www/2025-06-27_10_19/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment9nYUkmNaOEHV5jzivRBeg_lwDzvpMfLMFi_45ugyOc8H0Meta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialssoWcHmX0i0NetxLoC7FCHORq_bBXZVQms6wdPtlVczsMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsJtFXJTjY1BcD4A0tquO6FTk9D58Xc1A3B_45zhc5G9x0sMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentgSMBGd3dsf3te_45MhuKqVdy0yXbv8G7nZIG9ud8IR1CwMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationxRTGz4aZrDG72HzvLW68N1Uxa4uy2R_45eetGQJ5vTBXoMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93sW6aa5AWqad80WRmSAYUS3Tjo7kASbDzd9D8crfPpewMeta } from "/var/www/2025-06-27_10_19/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationI76hXqJHOegAoWV22jqklODD5hyk7GXFKgi4mr71DXcMeta } from "/var/www/2025-06-27_10_19/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-06-27_10_19/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-06-27_10_19/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-06-27_10_19/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-06-27_10_19/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93oHiNnPNQ04MwioAiy83LbBnlH6CqHCk1ujyPV_45tg_459UMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-06-27_10_19/pages/cookie.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-06-27_10_19/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-06-27_10_19/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-06-27_10_19/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-06-27_10_19/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursQ4gPSAyj7tTvKCfaP5Qtn0kj_eE_Ep2v83jFkLaGU4sMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-06-27_10_19/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-06-27_10_19/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-06-27_10_19/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactstoN8pWka_454dd1vJ2yOgZg0uWG35_453dwC8vjQyYrr5o0Meta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-06-27_10_19/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-06-27_10_19/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-06-27_10_19/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-06-27_10_19/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-06-27_10_19/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-06-27_10_19/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-06-27_10_19/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-06-27_10_19/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeIBcQ7iwkZfuj_Ly42DoXxymmAKJsHy7JG_T4Ji3wfEUMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93UGFK4zVHEKZKc9ILVJN9BV5N9g6t_45FqtbAbs2bKeuhIMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-06-27_10_19/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-06-27_10_19/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-06-27_10_19/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-06-27_10_19/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-06-27_10_19/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-06-27_10_19/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexfxeKW_H6OlKMm96tcN_45V7CqjxYjE4MPq4muk9RHA8roMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-06-27_10_19/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-06-27_10_19/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorJw2E7AwA1f6_WjQrJgTbxPCQanmiX4bVMCMmKCgzIAgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexjvJRdaAI54ZKqoltrof_45_45VUG6Ri1_45TBm0lsZseu_45U5sMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-06-27_10_19/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-06-27_10_19/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93glYDErLeCSd4JI7NUGFoCUKjz9rkdBpE5FBl1GK0iFYMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-06-27_10_19/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-06-27_10_19/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-06-27_10_19/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-06-27_10_19/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-06-27_10_19/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-06-27_10_19/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-06-27_10_19/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-06-27_10_19/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-06-27_10_19/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthday2FrupHA9Y4JFOT2HMMBxhqY2tvE_45M1KgDO6Kt1t1tQYMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: managey3CKEMEOjvRl_45XhKb_Jf_rGEBfCU5ovMNhK0g9YA9twMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-06-27_10_19/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-06-27_10_19/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsoPX92EaxCLzXVxEadUjsSo6mMpWvDbMc_1Xi6YLhIyAMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexE6CKGH5FR8ZuamXwly_UrxFMIM7WkM_45XYtpmXjOGJwgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-06-27_10_19/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-06-27_10_19/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-06-27_10_19/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: import1oMvRCTHFrU1JAZOmVpMR18lu65fMdyHyaSbj2ZvoOgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutJ_454FT7r2bHPhvl_tkFnOpYrG_456fQhYNTzXsmmendfXgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-06-27_10_19/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-06-27_10_19/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20247RS_eNCF1JsVPLJFz6T_uPYFDfZx_eKgXBCpp0ar2LIMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozon87bWWNgxgnNdJgRg9oUbvQOVUxc4eOkK31yfwb86U2YMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountGcHQrqP3fYT0_bRVnzi9gkX_uGLstsrGUbjXR9wE6TwMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-06-27_10_19/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-06-27_10_19/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-06-27_10_19/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-06-27_10_19/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorNl6KdcIqTxou89a3FAVRbK5YmBJpp6WUYnYq85MWPOwMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-06-27_10_19/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountR403Xfg_45SzEL_RfM2dL5d82X_7vuShwWaPtd_45tOrxeQMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-06-27_10_19/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient102019170ifR9w6v1lgyE9qGKbSKy1RU_45LP98K1bPmcLznIDXfEMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-06-27_10_19/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: index0TABsiajq9EzNtF_op4ZP901mbg7qO7rCFmGGFwgbNEMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesAiGX4_45wI1g0I0ozLXlugoRcfIHZmGH3qmqKFv7ajzAsMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_931Boc5aR0fZS5vD6bfLxIf5LyNMCGkJpJXgdOHYvX9GYMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printr7521oBYlctHYScsxVK9qfOzOqGWrUfuuzCef6ytLYIMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-06-27_10_19/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_9356bSwP1iZxDYmwxZZ7paCT6mR6ylBrjti6uROaucEQgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createLF1Z_za5_61HKh1l0B44lura9kPDVh1AXBsOJxPrVBYMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-06-27_10_19/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-06-27_10_19/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesVH0LbpJklTze26Icc1MtuzWAFh8oGI_hWA_45W4EVd4i4Meta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93ABWd3FkHuqpPLd5fKzCflQgFUmJwvbf9uSFYeK_455B0AMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexnqlEPnEFI5w81O_454RA2_kPZPw8ezB_45xMFyF9k3m_GskMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketCFSaQSVXMrWZy4r4DZHjDI8R1xS0pNNQuyeYg0lf7NsMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templateskbi_dLXZF48ySs62DTz7bwQ_nMN8SuyNgSVcogPzErgMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexytSm9rUJGwa6dp_pBjyg3zqPlOO9IJbNzyumGTgiOjMMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93LqcglZ4QSMtcgfgv0O4DrU0Gu1Ne_45u0PAZlUAjKCXpsMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexKtnTNUzV_DOyv8DG5tr91A96M1suC6Zxsdo8O29ONR8Meta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93GkBOftLlCTsb4q9VWY_45JwRTZmeqSBLYhIQYthyFv_vYMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: index1DpbrdYMt_9cRu40kP2Euh2RCoduZADhKQoFCFPqhP0Meta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexCuTwELQGNA22yDDT_45_45qi1B_EHj1KwJCPAo_CQHLmdhIMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93DtIVpPuCeDZXJ3pid6mxm_45_45dCAZq9sywUT_455y2i2QEwMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93QqB5v0YGNNAS8OunNXbc_45Oc3As_45yy_45c18ummU6qG8LUMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93UU8RBjrTvuCCG3Mafd6ico5w7B63mOULLX587m4JgUQMeta || {},
    component: () => import("/var/www/2025-06-27_10_19/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-06-27_10_19/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-06-27_10_19/pages/shippingtypes/personalitemstransportation.vue")
  }
]